import { getShopURL } from '@services/urls/apiGatewayURLs';
import { format } from '@utils/string';
import snakeToCamel from '@utils/array/snakeToCamel';

import ServiceResponse from '../models/ServiceResponse';

const message = 'shopLink param is required';

async function getShopInfoByLink({ axios, shopLink }) {
  try {
    if (!shopLink) return new ServiceResponse({ error: message });

    const encodedLink = encodeURIComponent(decodeURIComponent(shopLink));
    const url = format(getShopURL, encodedLink);
    const response = await axios.get(url);

    const shop = snakeToCamel(response.data);

    return new ServiceResponse({ data: { shop: shop.data } });
  } catch (error) {
    return new ServiceResponse({ error });
  }
}

export default getShopInfoByLink;
